import Link from "astro-typesafe-routes/link/react";

import type { SupportedOAuthProvider } from "~/utils/oauth";

export const AuthButton: React.FC<{
  provider: SupportedOAuthProvider;
  children: React.ReactNode;
}> = ({ children, provider }) => {
  return (
    <Link
      className="btn btn-outline btn-block grid grid-cols-[1fr_auto_1fr]"
      to="/api/auth/[provider]"
      params={{ provider }}
    >
      {children}
    </Link>
  );
};
